import React, { Component } from "react";
import XLSX from "xlsx";
import planilhas from "./planilhas";

// Usa a lib `xlsx` (SheetJS, já dependência do projeto) direto, em vez do
// padrão react-data-export usado em Relatorio/Cursos/Expor e Relatorio/
// Exportacao/Expor: react-data-export roda sobre um fork antigo (tempa-xlsx)
// que sabe estilizar célula (cor/negrito) mas não sabe escrever agrupamento de
// linha (`!rows[i].level`) — o recurso nativo do Excel (+/- na margem) que dá
// o "drilldown" de verdade pedido pelo usuário pra planilha "Resumo por
// modalidade". A `xlsx` free tem o inverso (agrupamento sim, estilo de célula
// não — isso é recurso pago do SheetJS Pro); as duas libs não podem escrever
// no mesmo arquivo, então a troca vale pro componente inteiro. Ver
// docs/PLANO_DASHBOARD_CONSOLIDADO.md, Fase 14.
// Unidade agora chega como array (filtro multi-select do FiltroBar) — nome do
// arquivo usa "Todas" se nada selecionado, o valor único se só um, ou junta
// os selecionados com "-" se vários.
function nomeUnidadeArquivo(unidade) {
    if (!Array.isArray(unidade)) return unidade || "Todas";
    if (unidade.length === 0) return "Todas";
    return unidade.join("-");
}

export default class Exportar extends Component {

    exportar = () => {
        let { linhas, mes, unidade } = this.props;
        let linhasCube = linhas || [];

        let wb = XLSX.utils.book_new();

        let resumoModalidade = planilhas.planilhaResumoModalidade(linhasCube, mes);
        let wsResumoModalidade = XLSX.utils.aoa_to_sheet(resumoModalidade.linhas);
        wsResumoModalidade["!cols"] = resumoModalidade.cols;
        wsResumoModalidade["!rows"] = resumoModalidade.metaLinhas;
        wsResumoModalidade["!outline"] = { above: true };
        XLSX.utils.book_append_sheet(wb, wsResumoModalidade, "Resumo por modalidade");

        let resumoUniplan = planilhas.planilhaResumoUniplan(linhasCube, mes);
        let wsResumoUniplan = XLSX.utils.aoa_to_sheet(resumoUniplan.linhas);
        wsResumoUniplan["!cols"] = resumoUniplan.cols;
        wsResumoUniplan["!merges"] = resumoUniplan.merges;
        XLSX.utils.book_append_sheet(wb, wsResumoUniplan, "Resumo UNIPLAN");

        let cursos = planilhas.planilhaCursos(linhasCube, mes);
        let wsCursos = XLSX.utils.aoa_to_sheet(cursos.linhas);
        wsCursos["!cols"] = cursos.cols;
        XLSX.utils.book_append_sheet(wb, wsCursos, "Cursos");

        XLSX.writeFile(wb, `DashboardConsolidado_${nomeUnidadeArquivo(unidade)}_${mes || "Anual"}.xlsx`);
    }

    render() {
        return <button className="btn btn-outline-info" onClick={this.exportar}>Exportar</button>;
    }
}
